import { Component, OnInit, Injector } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { AutoPrintReprintService } from '../../services/auto-print-reprint.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LaasOption } from 'src/app/core/models/laas-option';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';


@Component({
  selector: 'laas-autoprint-reprint',
  templateUrl: './autoprint-reprint.component.html',
  styleUrls: ['./autoprint-reprint.component.scss']
})
export class AutoprintReprintComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.AutoPrintReprint;
  currentLang: string = this.laasSetting.language;
  reprintParams:any;
  reprintForm: FormGroup;
  facilityOptions:LaasOption[]=[];
  printerCodeOptions:LaasOption[]=[];
  docTypeOptions:LaasOption[]=[];
  submitted: boolean = false;
  isLoading: boolean = false;

  constructor(private injector:Injector,private autoPrintReprintService:AutoPrintReprintService,
    private formBuilder: FormBuilder,private dropdownOptionsService:DropdownOptionsService){
    super(injector);
    this.reprintParams={
        facility:null,
        printer:null,
        createDtStart:null,
        createDtEnd:null,
        docType:[]
    }

    this.reprintForm = this.formBuilder.group({
      facility:[null, Validators.required],
      printer:[null, Validators.required],
      createDtStart:[new Date, Validators.required],
      createDtEnd:null,
      docType:[[],Validators.required]
    });

    this.dropdownOptionsService.getFacilityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.changeFacility(this.laasSetting.facility);
  }

  changeFacility(facility:string){
    this.getPrinterCode(facility);
    this.getDocType(facility);
  }

  getPrinterCode(facility:string):void{
    this.autoPrintReprintService.getPrinterCode(facility)
    .subscribe({
      next: (options:any[])=>{
          this.printerCodeOptions = options.map(x=>({
            label: x,
            value: x
          }))
        }
    });
  }

  getDocType(facility:string):void{
    this.autoPrintReprintService.getDocType(facility)
    .subscribe({
      next: (options:any[])=>{
        this.docTypeOptions = options.map(x=>({
          label: x,
          value: x
        }))
      }
    })
  }

  dateOnChange(date: any) {
      this.reprintForm.controls.createDtStart.setValue(date.startDate);
      this.reprintForm.controls.createDtEnd.setValue(date.endDate);
      this.reprintParams.createDtStart = date.startDate;
      this.reprintParams.createDtEnd = date.endDate;
  }

  printBtnClick(){
    if (this.reprintForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      this.loader.hide();
      return;
    }
    this.isLoading = true;
    this.autoPrintReprintService.reprintAutoPrint(this.reprintParams)
    .subscribe({
      next:(result:any)=>{
        if (result) {
          if(result.file){
            const byteStr = atob(result.file);
            const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
            const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteStr.length; i++) {
              int8Array[i] = byteStr.charCodeAt(i);
            }

            const data: Blob = new Blob([int8Array], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(data);
            const linkEle = document.createElement('a');
            linkEle.href = url;
            linkEle.download = `rePrintAutoPrintDoc_${result.fileName}`
            linkEle.click();
            URL.revokeObjectURL(url);
            linkEle.remove();
          }
          else if(result.fileName == "E"){
            this.toastService.warn("No auto print request needs to reprint.");
          }else{
            this.toastService.error("Can't get file, print faild");
          }
        }
      },
      error:(error)=>{
        this.toastService.error(error);
      },
      complete:()=>{
        this.isLoading=false;
      }
    })
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facility':
        this.reprintParams.facility = data;
        this.changeFacility(data);
        break;
    }
  }
}
